export const css = {
	root: '_3mzf3ZUM',
	clear: 'D25JZmQH',
	player: '_17RSTo87',
	playlist: '_25JlfPO3',
	playlistTitle: '_3Nx-BD3N',
	playlistItem: '_1hMx5nC1',
	' _key': 'afcpe-theme/afcpe/audio/audio'
};

export default css;
